import { css, Interpolation, Theme } from '@emotion/react';
import { ContainedIcon, IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';

export const AiContainedIcon = ({
  as = 'div',
  iconName = 'aiweave-assistant',
  containerStyles,
  size = 20,
}: {
  as?: React.ElementType;
  iconName?: IconName;
  containerStyles?: Interpolation<Theme>;
  size?: number;
}) => {
  return <ContainedIcon as={as} iconName={iconName} css={[AiBoxStyles, containerStyles]} size={size} />;
};

const AiBoxStyles = css`
  padding: 2px;
  border-radius: ${theme.borderRadius.small};
  background: linear-gradient(
    -90deg,
    ${theme.colors.primary10},
    ${theme.colors.secondary.seaweed5},
    ${theme.colors.primary10},
    ${theme.colors.secondary.seaweed5}
  );
  background-size: 400% 400%;
  animation: gradient 5s ease infinite;

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background: linear-gradient(
      -90deg,
      ${theme.colors.primary10},
      ${theme.colors.secondary.seaweed5},
      ${theme.colors.primary10},
      ${theme.colors.secondary.seaweed5}
    );
    background-size: 400% 400%;
    animation: gradient 5s ease infinite;
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;
